module.exports = __webpack_public_path__ + "img/high-level.63fc274c.png";